import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-cielo-dashboard',
  templateUrl: './cielo-dashboard.component.html',
  styleUrls: ['./cielo-dashboard.component.scss']
})
export class CieloDashboardComponent {
  @Input() scope;
}
